import { render, staticRenderFns } from "./CertificationUploader.vue?vue&type=template&id=c3b3817c&scoped=true&"
import script from "./CertificationUploader.vue?vue&type=script&lang=js&"
export * from "./CertificationUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b3817c",
  null
  
)

export default component.exports